import React from "react"
import { AddButton } from "src/containers/home/UI"
import styled from "styled-components"
import { useHistory } from "react-router"

const MainSeaction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflowx: hidden;
  height: 80%;
  padding: 20px;
  @media (min-width: 640px) {
    padding: 20px;
  }
`
const StyledTitle = styled.h1`
  text-decoration: none;
  margin-bottom: 20px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 32px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  color: rgb(60, 66, 64);
  @media (min-width: 640px) {
    white-space: pre-line;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
const NoListing = () => {
  const history = useHistory()
  const goToSearch = () => {
    history.push({
      pathname: `/search`
    })
  }
  return (
    <MainSeaction>
      <StyledTitle>
        Listing is no longer available{" "}
        <span role="img" aria-label="ghost emoji">
          👻
        </span>
      </StyledTitle>
      <AddButton style={{ cursor: "pointer" }} onClick={goToSearch}>
        Explore Homes
      </AddButton>
    </MainSeaction>
  )
}

export default NoListing
